import store from '../store'
import {
  ykDateFormat
} from '@/public/utils/globalFunc.js'
// import AXIOS from './index'

export default function writeSystemLog(response) {
  const URL = response.config.url
  const REQ_METHOD = response.config.method
  const REQ = response.config
  const RES = response.data
  const USER_NAME = `${store.state.userInfo.userName}${store.state.ipAndAddress.ip !== '' ? `(${store.state.ipAndAddress.ip} ${store.state.ipAndAddress.address})` : ''}`
  const USER_COMPANY = store.state.userInfo.company
  let str = ''
  // console.log(response)
  // 如果请求失败了则跳出方法
  if (!RES.isSuccess) {
    return null;
  }

  if (URL === '/login' && REQ_METHOD === 'post') {
    // 登录
    str = `${RES.data.company} ${RES.data.userName}${store.state.ipAndAddress.ip !== '' ? `(${store.state.ipAndAddress.ip} ${store.state.ipAndAddress.address})` : ''} 登陆了`
  } else if (URL === '/Bugs/YKBug/both' && REQ_METHOD === 'post') {
    const BODY = JSON.parse(REQ.data)
    str = `${USER_COMPANY} ${USER_NAME} 在 [${BODY.productionType}]${BODY.groupName}-${BODY.vuePath} 新增了 ${BODY.detailList.length} 条需求登记`
  } else if (URL === '/Bugs/YKBug/both' && REQ_METHOD === 'put') {
    const BODY = JSON.parse(REQ.data)
    str = `${USER_COMPANY} ${USER_NAME} 在 [${BODY.productionType}]${BODY.groupName}-${BODY.vuePath} 改动了 ${BODY.detailList.length} 条需求登记`
  } else if (URL === '/Bugs/YKDataProcessing' && REQ_METHOD === 'post') {
    const BODY = JSON.parse(REQ.data)
    str = `${USER_COMPANY} ${USER_NAME} 在 [${BODY.productionType}]${BODY.groupName}-${BODY.vuePath} 新增了数据处理`
  } else if (URL === '/Bugs/YKDataProcessing' && REQ_METHOD === 'put') {
    const BODY = JSON.parse(REQ.data)
    str = `${USER_COMPANY} ${USER_NAME} 在 [${BODY.productionType}]${BODY.groupName}-${BODY.vuePath} 改动了数据处理`
  } else if (URL === '/Bugs/YKDataProcessing' && REQ_METHOD === 'delete') {
    const BODY = JSON.parse(REQ.data)
    str = `${USER_COMPANY} ${USER_NAME} 删除了 ${BODY.logStr} 的数据处理`
  } else if (URL === '/Bugs/YKBug/handle' && REQ_METHOD === 'put') {
    const BODY = JSON.parse(REQ.data)
    str = `${USER_NAME} 对 [${BODY.productionType}]${BODY.groupName}-${BODY.vuePath} 的需求登记的${BODY.idList.length}条明细执行了 ${BODY.handleResult} 操作`
  } else if (URL === '/Bugs/YKBug/unhandle' && REQ_METHOD === 'put') {
    const BODY = JSON.parse(REQ.data)
    str = `${USER_NAME} 对 [${BODY.productionType}]${BODY.groupName}-${BODY.vuePath} 的需求登记的${BODY.idList.length}条明细执行了 ${BODY.handleResult === '取消' ? '取消处理' : '取消' + BODY.handleResult} 操作`
  } else if (URL === '/Common/YKCase/synchronize' && REQ_METHOD === 'post') {
    const BODY = JSON.parse(REQ.data)
    str = `${USER_NAME} 同步了${BODY.tableData.length}条问题至协作系统`
  } else if (URL === '/Bugs/YKDataProcessing/handle' && REQ_METHOD === 'put') {
    const BODY = JSON.parse(REQ.data)
    str = `${USER_NAME} 对${BODY.idList.length}条数据处理执行了 ${BODY.handleResult} 操作`
  }

  if (str) {
    return {
      actor: URL === '/login' ? RES.data.userName : store.state.userInfo.userName,
      action: '系统日志',
      actionTime: ykDateFormat('yyyy-MM-dd HH:mm:ss', new Date()),
      comment: str
    }
    // await AXIOS.post('/Bugs/YKAction/add', {
    //   actor: URL === '/login' ? RES.data.userName : store.state.userInfo.userName,
    //   action: '系统日志',
    //   actionTime: ykDateFormat('yyyy-MM-dd HH:mm:ss', new Date()),
    //   comment: str
    // })
  }
  return null
}